<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();

const changeLanguage = (event: Event) => {
  const target = event.target as HTMLSelectElement;
  locale.value = target.value;
};
</script>

<template>
  <div class="settings-container">
    <h1>{{ t('settings.title') }}</h1>
    <!-- 例: 言語設定、音量設定など -->
    <div class="setting-item">
      <label for="language">{{ t('settings.language') }}:</label>
      <select id="language" v-model="locale" @change="changeLanguage">
        <option value="ja">日本語</option>
        <option value="en">English</option>
      </select>
    </div>

  </div>
</template>

<style scoped>
.settings-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  box-sizing: border-box;
  font-family: 'Arial', sans-serif;
  background-color: #f9f9f9;
  color: #333;
}

h1 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 1.5rem;
}

p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
}

.setting-item {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 400px;
}

.setting-item label {
  font-size: 1.1rem;
  margin-right: 1rem;
  min-width: 80px;
}

.setting-item select,
.setting-item input[type="range"] {
  flex-grow: 1;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}
</style>
